<template>
  <div class="privacy-container">
<div class="tab-content">
<pre v-show="currentTab == 0" class="privacy-text">
<div class="tab-tit"><p>개인정보처리방침</p><span></span></div>
인성데이타주식회사(이하 “회사”라 함)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보 보호법, 통신 비밀 보호법, 전기 통신 사업법 등 정보 통신 서비스 제공자가 준수하여야 할 관련 법령상의 개인정보 보호 규정을 준수하며, 관련 법령에 의거한 개인정보 처리방침을 정하여 이용자 권익보호에 최선을 다하고 있습니다.
회사의 개인정보 처리방침은 정부의 법률 및 지침의 변경과 당사의 약관 및 내부 정책에 따라 변경될 수 있으며, 이를 개정하게 될 경우 변경사항에 대해서 적용일자 10일 전부터 적용일 이후 상당 기간동안 공지만 합니다. 회원에게 불리한 약관의 개정의 경우에는 그 적용일자 30일전부터 적용일 이후 상당한 기간 동안 각각 이를웹사이트 공지사항 또는 개별공지를 통하여 공지하거나 고객에게 전자우편, 전자쪽지 또는 로그인시 동의창 등의 전자적 수단을 통해 통지합니다.

회사는 개인정보 처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있음을 알려드리며 다음과 같은 내용을 담고 있습니다.

1. 수집하는 개인정보의 항목 및 수집방법
1) 수집하는 개인정보의 항목
① 회사는 회원구분, 원활한 서비스의 이용을 위해 최초 회원가입 당시 아래와 같은 최소한의 개인정보를 필수 항목으로 수집하고 있습니다.
A. 가맹점의 경우 : 상호, 사업자등록번호, 성명, 전화번호(핸드폰 포함), 이메일, 주소, 계좌정보
B. 일반회원의 경우 : 성명, 전화번호, 생년월일, 이메일, 주소
② 서비스 이용과정이나 사업의 처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
: IPAdress, 쿠키, 접속로그, 방문일시, 서비스 이용기록, 불량 이용기록
③ 유료서비스 이용과정에서 아래와 같은 결제 정보들이 수집될 수 있습니다.
A. 신용카드 결제 시 : 카드사정보, 카드번호
B. 휴대전화 결제 시 : 휴대전화번호, 통신사
C. 계좌이체시 : 은행명, 계좌번호, 예금주명
2) 개인정보의 수집방법  회사는 다음과 같은 방법으로 개인정보를 수집합니다.
① 홈페이지 회원등록 및 개인정보제공화면, 서면, 팩스, 전화, 이메일 등을 통한 수집
② APP 또는 어플 접속시 자동으로 수집

2. 개인정보의 수집 및 이용목적
1) 서비스 제공에 관한 계약이행 및 서비스 제공에 따른 정산
콘텐츠 제공, 물품배송 또는 청구서 등 발송, 금융거래 본인 인증 및 금융 서비스, 구매 및 요금 결제, 요금추심
2) 이용자 관리(회원관리)
① 서비스 이용가입 및 개인식별, 불량회원의 부정이용 방지와 비인가 사용 방지
② 이용약관 위반 이용자에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재
③ 서비스이용 가입횟수 제한, 불만처리 등 민원처리, 고지사항 전달, 서비스 이용 종료에 대한 의사확인
3) 신규 서비스 개발 및 마케팅 ․ 광고에의 활용
신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공,
접속빈도 파악, 회원의 서비스이용에 대한 통계 등을 위해 사용하며 이용자에게 보다 나은 서비스 혜택을 통해 이용자에게 제공할 수 있습니다.
단, 이용자가 서비스 혜택 정보 제공을 원치 않는다는 의사를 명확히 밝히는 경우 정보 제공을 하지 않습니다
4) 재화 또는 서비스 제공
주문/결제, 상품 배달, 맞춤서비스 제공, 본인인증, 연령인증 등을 목적으로 개인정보를 처리합니다.
5) 고충처리
민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락․통지, 처리결과 통보 등의 목적으로 개인정보를 처리합니다.

3. 수집하는 개인정보 항목 및 수집방법
1) 회원정보
<table>
  <tr>
    <th>수집, 이용 목적</th>
    <th>필수항목</th>
    <th>선택항목</th>
  </tr>
  <tr>
    <td>대구로 운영, 알림메세지 전송, 광고 및 마케팅</td>
    <td>• 개인식별정보
 - 단말기정보(디바이스ID, 구글AD ID등)
 - 위치정보</td>
    <td></td>
  </tr>
  <tr>
    <td>본인인증, 회원제 서비스이용, 중복회원 확인</td>
    <td>회원ID, 닉네임, 비밀번호,휴대전화번호
주소정보, 이메일주소, 이름, 생년월일, 성별</td>
    <td></td>
  </tr>
  <tr>
    <td>카카오계정을 이용한 회원가입</td>
    <td>• 수집정보 : 이메일주소,생일,닉네임,연령대
• 제공받는 정보 : 이메일주소,성별,카카오ID코드</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>네이버계정을 이용한 회원가입</td>
    <td>• 수집정보 : 이메일주소,생일,닉네임,연령대
• 제공받는 정보 : 이메일주소,성별,네이버ID코드</td>
    <td></td>
  </tr>
  <tr>
    <td>구글계정을 이용한 회원가입</td>
    <td>• 수집정보 : 이메일주소,생일,닉네임,연령대
• 제공받는 정보 : 이메일주소,성별,구글ID코드</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>결제서비스 이용</td>
    <td>• 결제정보 : 카드(신용,체크,선불)결제내역, 카드사명, 발급사명</td>
    <td></td>
  </tr>
  <tr>
    <td>주문서비스 이용</td>
    <td>• 픽업/테이블 주문서비스: 주문자정보,휴대전화번호,주문금액,상품정보
• 배달서비스: 주문자정보,휴대전화번호, 주문금액,주소,상품정보
• 예약서비스: 주문자정보,휴대전화번호,예약정보</td>
    <td></td>
  </tr>
  <tr>
    <td>문의(상담, 민원 등)</td>
    <td>• 이메일주소,성명</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>휴대전화인증(이용자 식별)</td>
    <td>• 제3자로부터 제공받은 개인정보: 휴대전화번호,CI,DI,생년월일,성별,내/외국인구분</td>
    <td></td>
  </tr>
  <tr>
    <td>리뷰작성, 서비스 및 상품이용 실적 확인</td>
    <td>• 수집한 모든 개인정보 항목
• 접속자정보,단말기 고유번호, 서비스이용기록 방문기록,광고 ID,휴대폰장치 ID</td>
    <td></td>
  </tr>
</table>

2) 비회원정보
<table>
  <tr>
    <th>수집, 이용 목적</th>
    <th>필수항목</th>
    <th>선택항목</th>
  </tr>
  <tr>
    <td>대구로 운영, 알림메세지 전송, 광고 및 마케팅</td>
    <td>• 개인식별정보
 - 단말기정보(디바이스ID, 구글AD ID등)
 - 위치정보</td>
    <td></td>
  </tr>
  <tr>
    <td>결제서비스 이용</td>
    <td>• 결제정보 : 카드(신용,체크,선불)결제내역, 카드사명, 발급사명</td>
    <td></td>
  </tr>
  <tr>
    <td>주문서비스 이용</td>
    <td>• 픽업/테이블 주문서비스: 주문자정보,휴대전화번호,주문금액,상품정보
• 배달서비스 : 주문자정보,휴대전화번호,주문금액,주소,상품정보
• 예약서비스: 주문자정보,휴대전화번호,예약정보
</td>
    <td></td>
  </tr>
  <tr>
    <td>문의(상담, 민원 등)</td>
    <td>• 이메일주소,성명</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>휴대전화인증(이용자 식별)</td>
    <td>• 제3자로부터 제공받은 개인정보: 휴대전화번호,CI,DI,생년월일,성별,내/외국인구분</td>
    <td></td>
  </tr>
  <tr>
    <td>리뷰작성, 서비스 및 상품이용 실적 확인</td>
    <td>• 단말기 고유번호</td>
    <td></td>
  </tr>
</table>

3) 서비스 이용과정이나 처리과정에서 자동, 또는 수동으로 생성되어 수집되는 정보
: 서비스 접속 일시, 서비스 이용 기록, 불량 혹은 비정상 이용기록, 결제 기록 등

이용자는 개인정보 수집 및 이용에 관한 동의를 거부할 수 있고 동의를 거부할 경우 관련 서비스의 이용이 불가능할 수 있습니다.

4. 개인정보의 공유 및 제공
회사는 고객님의 개인정보를 가입신청서, 서비스이용약관, 「개인정보처리방침」의 「개인정보의 수집 및 이용목적」에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업ㆍ기관에 제공하지 않습니다. 단, 다음의 경우에는 주의를 기울여 개인정보를 이용 및 제공할 수 있습니다.
① 이용자가 외부 제휴사의 서비스를 이용하기 위하여 개인정보 제공에 직접 동의를 한 경우
② 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

회사의 서비스 이행을 위하여 개인정보를 제3자에게 제공하고 있는 경우는 다음과 같다.
<table>
  <tr>
    <th>개인정보 이용 목적</th>
    <th>개인정보 제공받는 자</th>
    <th>개인정보 항목</th>
  </tr>
  <tr>
    <td>• 수사진행을 위한 협조요청
• 금융사고 조사 등을 위한 세무자료요청</td>
    <td>금융감독원,기타 수사기관 등 공공기관</td>
    <td>• 거래정보</td>
  </tr>
  <tr>
    <td>• 현금영수증 서비스 제공</td>
    <td>국세청</td>
    <td>• 거래정보,고유식별정보 휴대폰번호,카드번호</td>
  </tr>
  <tr>
    <td>• 거래승인,청구,정산,분쟁해결,통계자료활용,제휴업무에의 활용 등</td>
    <td>전카드사,직불카드 및 현금IC처리 전은행</td>
    <td>• 거래정보</td>
  </tr>
  <tr>
    <td>• 서비스제공(상품제조, 배달 등)
• 주문자정보 확인</td>
    <td>픽업,테이블주문,예약,배달음식 및 상품판매 업체</td>
    <td>• 회원
회원ID, 휴대전화번호주소,주문정보(상품 및 결제정보)
• 비회원
휴대전화번호,주소 주문정보(상품 및 결제정보)
</td>
  </tr>
  <tr>
    <td>• 서비스제공(배달주문 중개)</td>
    <td>배달대행사
배달중계플랫폼사</td>
    <td>• 회원
회원ID, 휴대전화번호, 주소 주문정보(상품 및 결제정보)
• 비회원
휴대전화번호,주소,주문정보(상품 및 결제정보)
</td>
  </tr>
  <tr>
    <td>• 행복페이 상품권 서비스</td>
    <td>대구은행</td>
    <td>• 회원
  회원ID, 휴대전화번호 고유식별정보, 계좌번호</td>
  </tr>
</table>
이용자는 개인정보 제3자 제공에 관한 동의를 거부할 수 있고 동의를 거부할 경우 관련 서비스의 이용이 불가능할 수 있습니다.

5. 개인정보의 취급 위탁
회사는 이용자의 사전동의 없이 개인정보를 외부업체에 위탁하지 아니하며 회사에서만 관리됩니다. 만일, 서비스 향상 또는 관계법령에 따라 위탁계약시에는 위탁 대상자와 위탁업무 내용에 대해 이용자에게 통지하고 필요한 경우 이용자의 사전 동의를 받아 처리하겠습니다.

6. 개인정보의 보유 및 이용기간
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간동안 보존합니다.
1) 회사내부 방침에 의한 정보보유 사유
① 부정이용기록(부정가입, 징계기록 등의 비정상적 서비스 이용기록)
② 보존이유 : 부정가입 및 이용방지(“부정이용기록”이란 부정 가입 및 운영원칙에 위배되는 행위로 인해 회사로부터 이용제한 등을 당한 기록을 말한다)
③ 보존기간 : 회원탈퇴 후 1년
2) 관련 법령에 의한 정보보유 사유
상법 및 전자상거래등에서 소비자보호에 관한 법률, 전자금융거래법, 여신전문금융업법 국세기본법, 법인세법, 부가가치세법, 조세특례제한법 등 관련 법령의 규정에 의하여 보존할 필요가 있는 경우 관계법에서 정한 일정기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
① 대금결제 및 재화 등의 공급에 관한 기록
A. 보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률
B. 보존기간 : 5년
② 전자금융거래에 관한 기록
A. 보존이유 : 전자금융거래법
B. 보존기간 : 5년
③ 본인확인에 관한 기록
A. 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률
B. 보존기간 : 6개월
④ 소비자의 불만 또는 분쟁처리에 관한 기록
A. 보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률
B. 보존기간 : 3년
⑤ 웹사이트의 방문기록
A. 보존이유 : 통신비밀보호법
B. 보존기간 : 3개월

⑥ 기타 법령에 의하여 수집 및 이용되는 개인 정보
A. 회원 가입 및 관리 : 탈퇴시까지. 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지
• 관계 법령 위반에 따른 수사․조사 등이 진행중인 경우에는 해당 수사․조사 종료시까지
• 서비스 이용에 따른 채권․채무관계 잔존시에는 해당 채권․채무관계 정산시까지
B. 재화 또는 서비스 제공 : 재화․서비스 공급완료 및 요금결제․정산 완료시까지. 다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료시까지
<table class="table-th-4">
  <tr>
    <th>법령/내부정책</th>
    <th>수집․이용목적</th>
    <th>수집항목</th>
    <th>보유․이용기간</th>
  </tr>
  <tr>
    <td rowspan="4">전자상거래 등에서의 소비자보호에 관한 법률</td>
    <td>표시․광고 관한 기록</td>
    <td>표시․광고 기록</td>
    <td>6개월</td>
  </tr>
  <tr>
    <td>대금결제/재화 등의 공급기록</td>
    <td>대금결제/재화 등의 공급기록</td>
    <td>5년</td>
  </tr>
  <tr>
    <td>계약 또는 청약철회 등에 관한 기록</td>
    <td>소비자 식별정보 계약/청약철회 기록</td>
    <td>5년</td>
  </tr>
  <tr>
    <td>소비자 불만 또는 분쟁처리에관한 기록</td>
    <td>소비자 식별정보 분쟁처리기록</td>
    <td>3년</td>
  </tr>
  <tr>
    <td>통신비밀보호법</td>
    <td>통신사실확인자료 제공</td>
    <td>로그기록, 접속지의 추적자료 등</td>
    <td>3개월</td>
  </tr>
</table>

7. 개인정보 파기절차 및 방법
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
1) 파기절차
① 이용자가 서비스이용가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부방침이나 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.
② 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
2) 파기방법
① 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
② 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.

8. 이용자 및 법정대리인의 권리와 그 행사 방법
1) 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입 해지(탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.
2) 이용자는 개인정보 조회, 수정을 위해서는 '개인정보 변경'(또는 '이용자 정보 수정' 등)을, 가입 해지(동의 철회)를 위해서는 "이용자 탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.
3) 혹은 개인정보 관리 책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치합니다.
4) 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리 결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
5) 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 "5. 개인정보의 보유 및 이용 기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.

9. 개인정보 자동수집 장치의 설치/운영 및 거부에 관한 사항
1) 회사에서는 수집한 이용자의 개인정보는 ID, 휴대폰번호, 이메일이며 수집을 거부하는 경우에는 앱을 즉시 삭제하시면 됩니다.
2) 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’ 등을 운용합니다.
① 쿠키란?
쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다. 이후 이용자가 웹 사이트에 방문할 경우 웹사이트 서버는 이용자의 하드디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다. 쿠키는 개인을 식별하는 정보를 자동적/능동적으로 수집하지 않으며, 이용자는 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.
② 회사의 쿠키사용 목적
이용자들이 방문한 인성데이타㈜의 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 뉴스 편집, 이용자 규모 등을 파악하여 이용자에게 광고를 포함한 최적화된 맞춤형 정보를 제공하기 위해 사용합니다.

③ 쿠키의 설치/운영 및 거부
이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다. 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스는 이용에 어려움이 있을 수 있습니다.

10. 개인정보의 열람, 정정, 삭제 동의 철회 절차
1) 개인정보의 열람
① 정보주체는 인성데이타(주)가 처리하는 자신의 개인정보에 대한 열람을 인성데이타(주)에게 요구할 수 있습니다.
② 인성데이타(주)는 정보주체의 열람을 요구받았을 때에는 그로부터 10일 이내에 정보주체가 열람할 수 있도록 제공합니다. 다만, 10일 이내에 열람할 수 없는 정당한 사유가 있을 때에는 정보주체에게 그 사유를 알리고 열람을 연기할 수 있으며, 그 사유가 소멸하면 지체 없이 열람할 수 있도록 제공합니다.
③ 인성데이타(주)는 다음 각 호의 어느 하나에 해당하는 경우에는 정보주체에게 그 사유를 알리고 열람 제한하거나 거절할 수 있습니다.
• 법률에 따라 열람이 금지되거나 제한되는 경우
• 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
2) 개인정보의 정정 ․ 삭제
① 정보주체는 인성데이타(주)에게 본인에 관한 개인정보의 정정 또는 삭제를 요구할 수 있습니다. 다만, 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
② 인성데이타(주)는 정보주체의 요구를 받았을 때에는 개인정보의 정정 또는 삭제에 관하여 다른 법령에 특별한 절차가 규정되어 있는 경우를 제외하고는 요구를 받은 날로부터 10일 이내에 그 개인정보를 조사하여 정보주체의 요구에 따라 정정·삭제 등 필요한 조치를 한 후 그 결과를 정보주체에게 알립니다.
3) 개인정보의 처리정지
① 정보주체는 인성데이타(주)에 대하여 자신의 개인정보 처리의 정지를 요구할 수 있습니다
② 인성데이타(주)는 제1항에 따른 요구를 받은 날로부터 10일 이내에 그 필요한 조치를 수행합니다. 다만, 다음 각 호의 어느 하나에 해당하는 경우에는 정보주체의 처리정지 요구를 거절할 수 있으며, 이 경우 정보주체에게 요구를 받은 날로부터 10일 이내에 그 사유를 알립니다.
• 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우
• 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
• 개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로서 정보주체가 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우

11. 개인정보의 기술적/관리적 보호 대책
회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.
1) 기술적 대책
① 개인정보처리자의 고객정보의 유출을 방지하기 위하여, 개인정보 유출방지 시스템을 운영하고 있으며, 단말기(모바일, PC) 및 네트워크 상의 전송되는 개인정보는 안전한 암호 알고리즘을 적용하고 있습니다.
② 인성데이타(주)는 안전한 암호알고리즘을 이용하여 네트워크상의 개인정보를 안전하게 전송할 수 있는 보안장치를 채택하고 있습니다.
③ 인성데이타(주)는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.
2) 관리적 대책
① 처리 직원의 최소화 및 교육
인성데이타(주)의 개인정보관련 처리 직원은 최소한의 인원으로 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 개인정보처리방침의 준수를 항상 강조하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.
• 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자
• 개인정보보호책임자 및 담당자 등 개인정보보호업무를 수행하는 자
• 기타 업무상 개인정보의 처리가 불가피한 자
② 개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확히 하고 있습니다.
③ 정보보호위원회의 운영
사내 정보정보보호위원회 등을 통하여 개인정보처리방침의 이행사항 및 담당자의 준수 여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다.
④ 전산실 및 자료 보관실 등을 통제구역으로 설정하여 출입을 통제하고 있습니다.
⑤ 인성데이타(주)는 컴퓨터를 이용하여 고객의 개인정보를 처리하는 경우 개인정보에 대한 접근 권한을 가진 담당자를 지정하여 식별부호(ID) 및 비밀번호를 부여하고, 해당 비밀번호를 정기적으로 갱신하고 있습니다
⑥ 인성데이타(주)는 신규직원 채용 시 정보보호서약서 또는 개인정보보호서약서에 서명함으로 직원에 의한 정보유출을 사전에 방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수 여부를 감사하기 위한 내부절차를 마련하여 지속적으로 시행하고 있습니다.
⑦ 인성데이타(주)는 직원 퇴직 시 비밀유지서약서에 서명함으로 회원의 개인정보를 처리하였던 자가 직무상 알게 된 개인정보를 훼손ㆍ침해 또는 누설하지 않도록 하고 있습니다.
⑧ 서비스이용계약체결 또는 서비스제공을 위하여 고객의 신용카드번호, 은행결제계좌 등 대금결제에 관한 정보를 수집하거나 고객에게 제공하는 경우 당해 고객이 본인임을 확인하기 위하여 필요한 조치를 취하고 있습니다.
⑨ 인성데이타(주)는 고객 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 회원의 경우 개개인이 본인의 개인정보를 보호하기 위해서 자신의 결제비밀번호, 계좌번호, 계좌비밀번호 등을 적절하게 관리하고 여기에 대한 책임을 져야 합니다.
⑩ 그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 위조, 변조, 훼손이 유발될 경우 “회사”는 즉각 고객님께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다.

12. 개인정보 관리책임자 및 담당자의 연락처
귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보 보호 관련 민원을 개인정보 관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.

■ 개인정보 총괄책임자
<table class="table-th-4-1">
  <tr>
    <td>성      명 :</td><td>하  병  환</td><td>직      위 :</td><td>부 사 장</td>
  </tr>
  <tr>
    <td>전화번호 :</td><td>1661-3773</td><td>메      일 :</td><td>hbh7443@isdata.kr</td>
  </tr>
</table>
■ 개인정보 관리책임자
<table class="table-th-4-1">
  <tr>
    <td>성      명 :</td><td>최  현  환</td><td>직      위 :</td><td>이  사</td>
  </tr>
  <tr>
    <td>전화번호 :</td><td>1661-3773</td><td>메      일 :</td><td>choi4016@isdata.kr</td>
  </tr>
</table>
■ 개인정보 관리담당자
<table class="table-th-4-1">
  <tr>
    <td>성      명 :</td><td>박  정  열</td><td>직      위 :</td><td>차  장</td>
  </tr>
  <tr>
    <td>전화번호 :</td><td>1661-3773</td><td>메      일 :</td><td>pjy@isdata.kr</td>
  </tr>
</table>
기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
• 개인정보침해 신고센터 : www.118.or.kr / 국번없이 118
• 대검찰청 사이버범죄 수사단 : www.spo.go.kr / 02-3480-2000
• 경찰청 사이버테러 대응센터 : www.ctrc.go.kr / 1566-0112

13. 고지의 의무
현 개인정보 처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 해당 앱의 ‘공지사항’을 통해 고지할 것 입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일전에 고지합니다.

부칙  이 약관은 2021년 8월 1일부터 시행합니다.




</pre>
<pre v-show="currentTab == 1" class="privacy-text">
<div class="tab-tit"><p>개인정보처리방침</p><span></span></div>
인성데이타주식회사(이하 “회사”라 함)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보 보호법, 통신 비밀 보호법, 전기 통신 사업법 등 정보 통신 서비스 제공자가 준수하여야 할 관련 법령상의 개인정보 보호 규정을 준수하며, 관련 법령에 의거한 개인정보 처리방침을 정하여 이용자 권익보호에 최선을 다하고 있습니다.
회사의 개인정보 처리방침은 정부의 법률 및 지침의 변경과 당사의 약관 및 내부 정책에 따라 변경될 수 있으며, 이를 개정하게 될 경우 변경사항에 대해서 적용일자 10일 전부터 적용일 이후 상당 기간동안 공지만 합니다. 회원에게 불리한 약관의 개정의 경우에는 그 적용일자 30일전부터 적용일 이후 상당한 기간 동안 각각 이를웹사이트 공지사항 또는 개별공지를 통하여 공지하거나 고객에게 전자우편, 전자쪽지 또는 로그인시 동의창 등의 전자적 수단을 통해 통지합니다.

회사는 개인정보 처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있음을 알려드리며 다음과 같은 내용을 담고 있습니다.

1. 수집하는 개인정보의 항목 및 수집방법
1) 수집하는 개인정보의 항목
① 회사는 회원구분, 원활한 서비스의 이용을 위해 최초 회원가입 당시 아래와 같은 최소한의 개인정보를 필수 항목으로 수집하고 있습니다.
A. 가맹점의 경우 : 상호, 사업자등록번호, 성명, 전화번호(핸드폰 포함), 이메일, 주소, 계좌정보
B. 일반회원의 경우 : 성명, 전화번호, 생년월일, 이메일, 주소
② 서비스 이용과정이나 사업의 처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
: IPAdress, 쿠키, 접속로그, 방문일시, 서비스 이용기록, 불량 이용기록
③ 유료서비스 이용과정에서 아래와 같은 결제 정보들이 수집될 수 있습니다.
A. 신용카드 결제 시 : 카드사정보, 카드번호
B. 휴대전화 결제 시 : 휴대전화번호, 통신사
C. 계좌이체시 : 은행명, 계좌번호, 예금주명
2) 개인정보의 수집방법  회사는 다음과 같은 방법으로 개인정보를 수집합니다.
① 홈페이지 회원등록 및 개인정보제공화면, 서면, 팩스, 전화, 이메일 등을 통한 수집
② APP 또는 어플 접속시 자동으로 수집

2. 개인정보의 수집 및 이용목적
1) 서비스 제공에 관한 계약이행 및 서비스 제공에 따른 정산
콘텐츠 제공, 물품배송 또는 청구서 등 발송, 금융거래 본인 인증 및 금융 서비스, 구매 및 요금 결제, 요금추심
2) 이용자 관리(회원관리)
① 서비스 이용가입 및 개인식별, 불량회원의 부정이용 방지와 비인가 사용 방지
② 이용약관 위반 이용자에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재
③ 서비스이용 가입횟수 제한, 불만처리 등 민원처리, 고지사항 전달, 서비스 이용 종료에 대한 의사확인
3) 신규 서비스 개발 및 마케팅 ․ 광고에의 활용
신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공,
접속빈도 파악, 회원의 서비스이용에 대한 통계 등을 위해 사용하며 이용자에게 보다 나은 서비스 혜택을 통해 이용자에게 제공할 수 있습니다.
단, 이용자가 서비스 혜택 정보 제공을 원치 않는다는 의사를 명확히 밝히는 경우 정보 제공을 하지 않습니다
4) 재화 또는 서비스 제공
주문/결제, 상품 배달, 맞춤서비스 제공, 본인인증, 연령인증 등을 목적으로 개인정보를 처리합니다.
5) 고충처리
민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락․통지, 처리결과 통보 등의 목적으로 개인정보를 처리합니다.

3. 수집하는 개인정보 항목 및 수집방법
1) 회원정보
<table>
  <tr>
    <th>수집, 이용 목적</th>
    <th>필수항목</th>
    <th>선택항목</th>
  </tr>
  <tr>
    <td>대구로 운영, 알림메세지 전송, 광고 및 마케팅</td>
    <td>• 개인식별정보
 - 단말기정보(디바이스ID, 구글AD ID등)
 - 위치정보</td>
    <td></td>
  </tr>
  <tr>
    <td>본인인증, 회원제 서비스이용, 중복회원 확인</td>
    <td>회원ID, 닉네임, 비밀번호,휴대전화번호
주소정보, 이메일주소, 이름, 생년월일, 성별</td>
    <td></td>
  </tr>
  <tr>
    <td>카카오계정을 이용한 회원가입</td>
    <td>• 수집정보 : 이메일주소,생일,닉네임,연령대
• 제공받는 정보 : 이메일주소,성별,카카오ID코드</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>네이버계정을 이용한 회원가입</td>
    <td>• 수집정보 : 이메일주소,생일,닉네임,연령대
• 제공받는 정보 : 이메일주소,성별,네이버ID코드</td>
    <td></td>
  </tr>
  <tr>
    <td>구글계정을 이용한 회원가입</td>
    <td>• 수집정보 : 이메일주소,생일,닉네임,연령대
• 제공받는 정보 : 이메일주소,성별,구글ID코드</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>결제서비스 이용</td>
    <td>• 결제정보 : 카드(신용,체크,선불)결제내역, 카드사명, 발급사명</td>
    <td></td>
  </tr>
  <tr>
    <td>주문서비스 이용</td>
    <td>• 픽업/테이블 주문서비스: 주문자정보,휴대전화번호,주문금액,상품정보
• 배달서비스: 주문자정보,휴대전화번호, 주문금액,주소,상품정보
• 예약서비스: 주문자정보,휴대전화번호,예약정보</td>
    <td></td>
  </tr>
  <tr>
    <td>문의(상담, 민원 등)</td>
    <td>• 이메일주소,성명</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>휴대전화인증(이용자 식별)</td>
    <td>• 제3자로부터 제공받은 개인정보: 휴대전화번호,CI,DI,생년월일,성별,내/외국인구분</td>
    <td></td>
  </tr>
  <tr>
    <td>리뷰작성, 서비스 및 상품이용 실적 확인</td>
    <td>• 수집한 모든 개인정보 항목
• 접속자정보,단말기 고유번호, 서비스이용기록 방문기록,광고 ID,휴대폰장치 ID</td>
    <td></td>
  </tr>
</table>

2) 비회원정보
<table>
  <tr>
    <th>수집, 이용 목적</th>
    <th>필수항목</th>
    <th>선택항목</th>
  </tr>
  <tr>
    <td>대구로 운영, 알림메세지 전송, 광고 및 마케팅</td>
    <td>• 개인식별정보
 - 단말기정보(디바이스ID, 구글AD ID등)
 - 위치정보</td>
    <td></td>
  </tr>
  <tr>
    <td>결제서비스 이용</td>
    <td>• 결제정보 : 카드(신용,체크,선불)결제내역, 카드사명, 발급사명</td>
    <td></td>
  </tr>
  <tr>
    <td>주문서비스 이용</td>
    <td>• 픽업/테이블 주문서비스: 주문자정보,휴대전화번호,주문금액,상품정보
• 배달서비스 : 주문자정보,휴대전화번호,주문금액,주소,상품정보
• 예약서비스: 주문자정보,휴대전화번호,예약정보
</td>
    <td></td>
  </tr>
  <tr>
    <td>문의(상담, 민원 등)</td>
    <td>• 이메일주소,성명</td>
    <td>• 휴대전화번호</td>
  </tr>
  <tr>
    <td>휴대전화인증(이용자 식별)</td>
    <td>• 제3자로부터 제공받은 개인정보: 휴대전화번호,CI,DI,생년월일,성별,내/외국인구분</td>
    <td></td>
  </tr>
  <tr>
    <td>리뷰작성, 서비스 및 상품이용 실적 확인</td>
    <td>• 단말기 고유번호</td>
    <td></td>
  </tr>
</table>

3) 서비스 이용과정이나 처리과정에서 자동, 또는 수동으로 생성되어 수집되는 정보
: 서비스 접속 일시, 서비스 이용 기록, 불량 혹은 비정상 이용기록, 결제 기록 등

이용자는 개인정보 수집 및 이용에 관한 동의를 거부할 수 있고 동의를 거부할 경우 관련 서비스의 이용이 불가능할 수 있습니다.

4. 개인정보의 공유 및 제공
회사는 고객님의 개인정보를 가입신청서, 서비스이용약관, 「개인정보처리방침」의 「개인정보의 수집 및 이용목적」에서 고지한 범위 내에서 사용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업ㆍ기관에 제공하지 않습니다. 단, 다음의 경우에는 주의를 기울여 개인정보를 이용 및 제공할 수 있습니다.
① 이용자가 외부 제휴사의 서비스를 이용하기 위하여 개인정보 제공에 직접 동의를 한 경우
② 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

회사의 서비스 이행을 위하여 개인정보를 제3자에게 제공하고 있는 경우는 다음과 같다.
<table>
  <tr>
    <th>개인정보 이용 목적</th>
    <th>개인정보 제공받는 자</th>
    <th>개인정보 항목</th>
  </tr>
  <tr>
    <td>• 수사진행을 위한 협조요청
• 금융사고 조사 등을 위한 세무자료요청</td>
    <td>금융감독원,기타 수사기관 등 공공기관</td>
    <td>• 거래정보</td>
  </tr>
  <tr>
    <td>• 현금영수증 서비스 제공</td>
    <td>국세청</td>
    <td>• 거래정보,고유식별정보 휴대폰번호,카드번호</td>
  </tr>
  <tr>
    <td>• 거래승인,청구,정산,분쟁해결,통계자료활용,제휴업무에의 활용 등</td>
    <td>전카드사,직불카드 및 현금IC처리 전은행</td>
    <td>• 거래정보</td>
  </tr>
  <tr>
    <td>• 서비스제공(상품제조, 배달 등)
• 주문자정보 확인</td>
    <td>픽업,테이블주문,예약,배달음식 및 상품판매 업체</td>
    <td>• 회원
회원ID, 휴대전화번호주소,주문정보(상품 및 결제정보)
• 비회원
휴대전화번호,주소 주문정보(상품 및 결제정보)
</td>
  </tr>
  <tr>
    <td>• 서비스제공(배달주문 중개)</td>
    <td>배달대행사
배달중계플랫폼사</td>
    <td>• 회원
회원ID, 휴대전화번호, 주소 주문정보(상품 및 결제정보)
• 비회원
휴대전화번호,주소,주문정보(상품 및 결제정보)
</td>
  </tr>
  <tr>
    <td>• 행복페이 상품권 서비스</td>
    <td>대구은행</td>
    <td>• 회원
  회원ID, 휴대전화번호 고유식별정보, 계좌번호</td>
  </tr>
</table>
이용자는 개인정보 제3자 제공에 관한 동의를 거부할 수 있고 동의를 거부할 경우 관련 서비스의 이용이 불가능할 수 있습니다.

5. 개인정보의 취급 위탁
회사는 이용자의 사전동의 없이 개인정보를 외부업체에 위탁하지 아니하며 회사에서만 관리됩니다. 만일, 서비스 향상 또는 관계법령에 따라 위탁계약시에는 위탁 대상자와 위탁업무 내용에 대해 이용자에게 통지하고 필요한 경우 이용자의 사전 동의를 받아 처리하겠습니다.

6. 개인정보의 보유 및 이용기간
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간동안 보존합니다.
1) 회사내부 방침에 의한 정보보유 사유
① 부정이용기록(부정가입, 징계기록 등의 비정상적 서비스 이용기록)
② 보존이유 : 부정가입 및 이용방지(“부정이용기록”이란 부정 가입 및 운영원칙에 위배되는 행위로 인해 회사로부터 이용제한 등을 당한 기록을 말한다)
③ 보존기간 : 회원탈퇴 후 1년
2) 관련 법령에 의한 정보보유 사유
상법 및 전자상거래등에서 소비자보호에 관한 법률, 전자금융거래법, 여신전문금융업법 국세기본법, 법인세법, 부가가치세법, 조세특례제한법 등 관련 법령의 규정에 의하여 보존할 필요가 있는 경우 관계법에서 정한 일정기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
① 대금결제 및 재화 등의 공급에 관한 기록
A. 보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률
B. 보존기간 : 5년
② 전자금융거래에 관한 기록
A. 보존이유 : 전자금융거래법
B. 보존기간 : 5년
③ 본인확인에 관한 기록
A. 보존이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률
B. 보존기간 : 6개월
④ 소비자의 불만 또는 분쟁처리에 관한 기록
A. 보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률
B. 보존기간 : 3년
⑤ 웹사이트의 방문기록
A. 보존이유 : 통신비밀보호법
B. 보존기간 : 3개월

⑥ 기타 법령에 의하여 수집 및 이용되는 개인 정보
A. 회원 가입 및 관리 : 탈퇴시까지. 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지
• 관계 법령 위반에 따른 수사․조사 등이 진행중인 경우에는 해당 수사․조사 종료시까지
• 서비스 이용에 따른 채권․채무관계 잔존시에는 해당 채권․채무관계 정산시까지
B. 재화 또는 서비스 제공 : 재화․서비스 공급완료 및 요금결제․정산 완료시까지. 다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료시까지
<table class="table-th-4">
  <tr>
    <th>법령/내부정책</th>
    <th>수집․이용목적</th>
    <th>수집항목</th>
    <th>보유․이용기간</th>
  </tr>
  <tr>
    <td rowspan="4">전자상거래 등에서의 소비자보호에 관한 법률</td>
    <td>표시․광고 관한 기록</td>
    <td>표시․광고 기록</td>
    <td>6개월</td>
  </tr>
  <tr>
    <td>대금결제/재화 등의 공급기록</td>
    <td>대금결제/재화 등의 공급기록</td>
    <td>5년</td>
  </tr>
  <tr>
    <td>계약 또는 청약철회 등에 관한 기록</td>
    <td>소비자 식별정보 계약/청약철회 기록</td>
    <td>5년</td>
  </tr>
  <tr>
    <td>소비자 불만 또는 분쟁처리에관한 기록</td>
    <td>소비자 식별정보 분쟁처리기록</td>
    <td>3년</td>
  </tr>
  <tr>
    <td>통신비밀보호법</td>
    <td>통신사실확인자료 제공</td>
    <td>로그기록, 접속지의 추적자료 등</td>
    <td>3개월</td>
  </tr>
</table>

7. 개인정보 파기절차 및 방법
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
1) 파기절차
① 이용자가 서비스이용가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부방침이나 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.
② 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
2) 파기방법
① 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
② 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.

8. 이용자 및 법정대리인의 권리와 그 행사 방법
1) 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입 해지(탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.
2) 이용자는 개인정보 조회, 수정을 위해서는 '개인정보 변경'(또는 '이용자 정보 수정' 등)을, 가입 해지(동의 철회)를 위해서는 "이용자 탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.
3) 혹은 개인정보 관리 책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치합니다.
4) 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리 결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
5) 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 "5. 개인정보의 보유 및 이용 기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.

9. 개인정보 자동수집 장치의 설치/운영 및 거부에 관한 사항
1) 회사에서는 수집한 이용자의 개인정보는 ID, 휴대폰번호, 이메일이며 수집을 거부하는 경우에는 앱을 즉시 삭제하시면 됩니다.
2) 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’ 등을 운용합니다.
① 쿠키란?
쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다. 이후 이용자가 웹 사이트에 방문할 경우 웹사이트 서버는 이용자의 하드디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다. 쿠키는 개인을 식별하는 정보를 자동적/능동적으로 수집하지 않으며, 이용자는 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.
② 회사의 쿠키사용 목적
이용자들이 방문한 인성데이타㈜의 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 뉴스 편집, 이용자 규모 등을 파악하여 이용자에게 광고를 포함한 최적화된 맞춤형 정보를 제공하기 위해 사용합니다.

③ 쿠키의 설치/운영 및 거부
이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다. 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스는 이용에 어려움이 있을 수 있습니다.

10. 개인정보의 열람, 정정, 삭제 동의 철회 절차
1) 개인정보의 열람
① 정보주체는 인성데이타(주)가 처리하는 자신의 개인정보에 대한 열람을 인성데이타(주)에게 요구할 수 있습니다.
② 인성데이타(주)는 정보주체의 열람을 요구받았을 때에는 그로부터 10일 이내에 정보주체가 열람할 수 있도록 제공합니다. 다만, 10일 이내에 열람할 수 없는 정당한 사유가 있을 때에는 정보주체에게 그 사유를 알리고 열람을 연기할 수 있으며, 그 사유가 소멸하면 지체 없이 열람할 수 있도록 제공합니다.
③ 인성데이타(주)는 다음 각 호의 어느 하나에 해당하는 경우에는 정보주체에게 그 사유를 알리고 열람 제한하거나 거절할 수 있습니다.
• 법률에 따라 열람이 금지되거나 제한되는 경우
• 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
2) 개인정보의 정정 ․ 삭제
① 정보주체는 인성데이타(주)에게 본인에 관한 개인정보의 정정 또는 삭제를 요구할 수 있습니다. 다만, 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
② 인성데이타(주)는 정보주체의 요구를 받았을 때에는 개인정보의 정정 또는 삭제에 관하여 다른 법령에 특별한 절차가 규정되어 있는 경우를 제외하고는 요구를 받은 날로부터 10일 이내에 그 개인정보를 조사하여 정보주체의 요구에 따라 정정·삭제 등 필요한 조치를 한 후 그 결과를 정보주체에게 알립니다.
3) 개인정보의 처리정지
① 정보주체는 인성데이타(주)에 대하여 자신의 개인정보 처리의 정지를 요구할 수 있습니다
② 인성데이타(주)는 제1항에 따른 요구를 받은 날로부터 10일 이내에 그 필요한 조치를 수행합니다. 다만, 다음 각 호의 어느 하나에 해당하는 경우에는 정보주체의 처리정지 요구를 거절할 수 있으며, 이 경우 정보주체에게 요구를 받은 날로부터 10일 이내에 그 사유를 알립니다.
• 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우
• 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
• 개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로서 정보주체가 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우

11. 개인정보의 기술적/관리적 보호 대책
회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.
1) 기술적 대책
① 개인정보처리자의 고객정보의 유출을 방지하기 위하여, 개인정보 유출방지 시스템을 운영하고 있으며, 단말기(모바일, PC) 및 네트워크 상의 전송되는 개인정보는 안전한 암호 알고리즘을 적용하고 있습니다.
② 인성데이타(주)는 안전한 암호알고리즘을 이용하여 네트워크상의 개인정보를 안전하게 전송할 수 있는 보안장치를 채택하고 있습니다.
③ 인성데이타(주)는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.
2) 관리적 대책
① 처리 직원의 최소화 및 교육
인성데이타(주)의 개인정보관련 처리 직원은 최소한의 인원으로 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 개인정보처리방침의 준수를 항상 강조하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.
• 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자
• 개인정보보호책임자 및 담당자 등 개인정보보호업무를 수행하는 자
• 기타 업무상 개인정보의 처리가 불가피한 자
② 개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확히 하고 있습니다.
③ 정보보호위원회의 운영
사내 정보정보보호위원회 등을 통하여 개인정보처리방침의 이행사항 및 담당자의 준수 여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다.
④ 전산실 및 자료 보관실 등을 통제구역으로 설정하여 출입을 통제하고 있습니다.
⑤ 인성데이타(주)는 컴퓨터를 이용하여 고객의 개인정보를 처리하는 경우 개인정보에 대한 접근 권한을 가진 담당자를 지정하여 식별부호(ID) 및 비밀번호를 부여하고, 해당 비밀번호를 정기적으로 갱신하고 있습니다
⑥ 인성데이타(주)는 신규직원 채용 시 정보보호서약서 또는 개인정보보호서약서에 서명함으로 직원에 의한 정보유출을 사전에 방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수 여부를 감사하기 위한 내부절차를 마련하여 지속적으로 시행하고 있습니다.
⑦ 인성데이타(주)는 직원 퇴직 시 비밀유지서약서에 서명함으로 회원의 개인정보를 처리하였던 자가 직무상 알게 된 개인정보를 훼손ㆍ침해 또는 누설하지 않도록 하고 있습니다.
⑧ 서비스이용계약체결 또는 서비스제공을 위하여 고객의 신용카드번호, 은행결제계좌 등 대금결제에 관한 정보를 수집하거나 고객에게 제공하는 경우 당해 고객이 본인임을 확인하기 위하여 필요한 조치를 취하고 있습니다.
⑨ 인성데이타(주)는 고객 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 회원의 경우 개개인이 본인의 개인정보를 보호하기 위해서 자신의 결제비밀번호, 계좌번호, 계좌비밀번호 등을 적절하게 관리하고 여기에 대한 책임을 져야 합니다.
⑩ 그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 위조, 변조, 훼손이 유발될 경우 “회사”는 즉각 고객님께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다.

12. 개인정보 보호책임자 및 담당자의 연락처
귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보 보호 관련 민원을 개인정보 관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.

■ 개인정보 보호책임자
<table class="table-th-4-1">
  <tr>
    <td>성      명 :</td><td>김  성  근</td><td>직      위 :</td><td>이  사</td>
  </tr>
  <tr>
    <td>전화번호 :</td><td>1661-3773</td><td>메      일 :</td><td>skkim@insungdata.kr</td>
  </tr>
</table>
■ 개인정보 보호관리자
<table class="table-th-4-1">
  <tr>
    <td>성      명 :</td><td>박  정  열</td><td>직      위 :</td><td>차  장</td>
  </tr>
  <tr>
    <td>전화번호 :</td><td>1661-3773</td><td>메      일 :</td><td>pjy@isdata.kr</td>
  </tr>
</table>
기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
• 개인정보침해 신고센터 : www.118.or.kr / 국번없이 118
• 대검찰청 사이버범죄 수사단 : www.spo.go.kr / 02-3480-2000
• 경찰청 사이버테러 대응센터 : www.ctrc.go.kr / 1566-0112

13. 고지의 의무
현 개인정보 처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 해당 앱의 ‘공지사항’을 통해 고지할 것 입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일전에 고지합니다.

부칙  이 약관은 2021년 8월 27일부터 시행합니다.



<ul class="tab-ul"><li v-bind:class="{active:currentTab===index}"><a href="#" v-on:click="currentTab = 0" @click="window.scrollTo(0, 0);">{{ tabs[0] }}</a></li></ul>
</pre>
<!--      <ul class="tab-ul">-->
<!--        <li v-for="(tab, index) in tabs" v-bind:key="tab" v-bind:class="{active:currentTab===index}">-->
<!--          <a href="#" v-on:click="currentTab = index" @click="window.scrollTo(0, 0);">{{ tabs[index] }}</a>-->
<!--        </li>-->
<!--      </ul>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  data(){
    return{
      currentTab: 1,
      tabs: ['시행일 : 2021.08.01 ~ 2021.08.26','시행일 : 2021.09.03']
    }
  }
}
</script>

<style scoped>
  table{
    width: 100%;
    margin: 15px 0;
    border-spacing: 0;
    border-collapse: collapse;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
  table tr{
    border-top: 1px solid #eee;
  }
  table tr th{
    padding: 10px 0;
    font-size:13px;
  }
  table tr th:nth-child(1){width: 30%;}
  table tr th:nth-child(2){width: 45%;}
  table tr th:nth-child(3){width: 25%;}
  table.table-th-4 tr th:nth-child(1){width: 30%;}
  table.table-th-4 tr th:nth-child(2){width: 30%;}
  table.table-th-4 tr th:nth-child(3){width: 30%;}
  table.table-th-4 tr th:nth-child(4){width: 10%;}
  table.table-th-4-1 tr td:nth-child(1){width: 25%;}
  table.table-th-4-1 tr td:nth-child(2){width: 25%;}
  table.table-th-4-1 tr td:nth-child(3){width: 25%;}
  table.table-th-4-1 tr td:nth-child(4){width: 25%;}
  table.table-th-4 tr td{text-align: center;}
  table tr td{
    padding: 15px 10px;
    text-align: justify;
    font-size: 12px;
  }
  .privacy-container{
    padding: 50px;
  }
  .privacy-text{
    font-family: "NanumSquareNeoBold";
    padding: 30px 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    text-align: justify;
    font-size: 13px;
  }
  .tab-select{
    overflow: hidden;
    border-bottom: 1px solid #333;
    padding-bottom: 15px;
    font-size: 25px;
  }
  .tab-select ul{
    font-family: "NanumSquareNeoBold";
    list-style: none;
    border: 1px solid #333;
    width: 180px;
    padding: 10px 30px 10px 10px;
    float: right;
    font-size: 14px;
  }
  .tab-tit{
    font-family: "NanumSquareNeoBold";
    overflow: hidden;
    border-bottom: 1px solid #333;
    font-size: 25px;
  }
  .tab-tit p{
    float: left;
  }
  .tab-tit span{
    float: right;
    margin-top: 10px;
    font-size: 14px;
  }
  .tab-ul{
    font-family: "NanumSquareNeoBold";
  }
  .tab-ul li a{
    color: #333;
  }
  .tab-ul li:hover a{
    transition: all 0.3s;
    color: #1fc7ff;
  }

  @media all and (min-width: 1024px){
    .privacy-container{
      width: 1280px;
      margin: 0 auto;
    }
  }
  @media all and (min-width: 768px) and (max-width: 1023px){
    .privacy-container{
      width: 768px;
      margin: 0 auto;
    }
  }
  @media all and (max-width: 767px){
    .privacy-container{
      width: 100%;
      padding: 25px;
    }
  }
</style>